export const APPLICANT_PROFILE_BLOCK_PARAM = 'block'

export const APPLICANT_PROFILE_BLOCK = {
  decision: 'decision',
}

export const APPLICANT_PAYLOAD_FIELD = {
  attention: 'attention',
  match: 'match',
  stage: 'stage',
}

export const APPLICANT_STAGE = {
  approved: 'approved',
  pool: 'pool',
  rejected: 'rejected',
  screening: 'screening',
  selected: 'selected',
  withdrawn: 'withdrawn',
}

export const APPLICANT_STAGE_LIST = [
  APPLICANT_STAGE.pool,
  APPLICANT_STAGE.screening,
  APPLICANT_STAGE.selected,
  APPLICANT_STAGE.approved,
  APPLICANT_STAGE.rejected,
  APPLICANT_STAGE.withdrawn,
]

export const APPLICANT_STAGES = {
  [APPLICANT_STAGE.approved]: {
    text: 'RentalPortal.ApplicantStageApprovedKey',
    textColor: 'var(--color-success)',
  },
  [APPLICANT_STAGE.pool]: {
    text: 'RentalPortal.ApplicantStagePoolKey',
    textColor: 'var(--secondary-text-color)',
  },
  [APPLICANT_STAGE.rejected]: {
    text: 'RentalPortal.ApplicantStageRejectedKey',
    textColor: 'var(--secondary-text-color)',
  },
  [APPLICANT_STAGE.screening]: {
    text: 'RentalPortal.ApplicantStageScreeningKey',
    textColor: 'var(--color-info)',
  },
  [APPLICANT_STAGE.selected]: {
    text: 'RentalPortal.ApplicantStageSelectedKey',
    textColor: 'var(--color-success)',
  },
  [APPLICANT_STAGE.withdrawn]: {
    text: 'RentalPortal.ApplicantStageWithdrawnKey',
    textColor: 'var(--secondary-text-color)',
  },
}

export const APPLICANT_MASKED_TEXT_COLOR = 'var(--secondary-text-color)'

export const APPLICANT_CREDIT_CHECK_BAND = {
  inconclusive: 'inconclusive',
  negative: 'negative',
  neutral: 'neutral',
  positive: 'positive',
}

export const APPLICANT_CREDIT_CHECK_BAND_LABEL_KEY = {
  [APPLICANT_CREDIT_CHECK_BAND.inconclusive]:
    'RentalPortal.ApplicantCreditCheckBandInconclusiveKey',
  [APPLICANT_CREDIT_CHECK_BAND.negative]:
    'RentalPortal.ApplicantCreditCheckBandNegativeKey',
  [APPLICANT_CREDIT_CHECK_BAND.neutral]:
    'RentalPortal.ApplicantCreditCheckBandNeutralKey',
  [APPLICANT_CREDIT_CHECK_BAND.positive]:
    'RentalPortal.ApplicantCreditCheckBandPositiveKey',
}

export const APPLICANT_CREDIT_CHECK_BAND_TEXT_COLOR = {
  [APPLICANT_CREDIT_CHECK_BAND.inconclusive]: 'var(--color-info)',
  [APPLICANT_CREDIT_CHECK_BAND.negative]: 'var(--color-error)',
  [APPLICANT_CREDIT_CHECK_BAND.neutral]: 'var(--secondary-text-color)',
  [APPLICANT_CREDIT_CHECK_BAND.positive]: 'var(--color-success)',
}

export const APPLICANT_COMPARISON_STAGES = [
  APPLICANT_STAGE.screening,
  APPLICANT_STAGE.selected,
  APPLICANT_STAGE.approved,
]

export const APPLICANT_FORM_FIELD_NAME_HOUSEHOLD_SIZE = 'household_size'

export const APPLICANT_FORM_FIELD_NAME_MOVE_IN_DATE = 'move_in_date'

export const APPLICANTS_FILTER_PARAM = {
  awaitingMyApproval: 'awaiting_my_approval',
  eligibility: 'eligibility',
  listing: 'listing_id',
  needsMyAction: 'needs_my_action',
  receivedGte: 'received_gte',
  receivedLte: 'received_lte',
  responsibleUser: 'responsible_user',
  source: 'source',
  stage: 'stage',
}

export const APPLICANT_TRANSITION_ACTION = {
  moveToScreening: 'move-to-screening',
  reject: 'reject',
  reveal: 'reveal',
  withdraw: 'withdraw',
}

export const APPLICANT_REVEAL_IDENTITY_TRANSITION = 'reveal_identity'
